import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';
import 'react-table/react-table.css';
import './Quick-Answer.scss';
import { withRouter } from 'react-router-dom';
import InputTag from '../../Components/Input-Tag/Input-Tag'


const SearchDetails = (props, { history }) => {

    const [loading, setLoading] = useState(true)
    const [modalExcluir, setModalExcluir] = useState(false)
    const [idFrase, setIdFrase] = useState()

    const [loadingAdicionar, setLoadingAdicionar] = useState(false)
    const [loadingExcluir, setLoadingExcluir] = useState(false)
    const [tags, setTags] = useState([])
    const [formState, setFormState] = useState({
        palavraChave: '',
    })

    const editar = props.match.params.idPesquisa

    const chamaFrase = () => {
        const id = props.match.params.idPesquisa
        const config = new Configurations();
        axios.get(config.apiBasePath + `/sinonimos/${id}`)
            .then(response => {
                setTags(response.data.data[0].sinonimos)
                setFormState({
                    palavraChave: response.data.data[0].palavraChave,
                })
                setIdFrase(id)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)

            });
    }


    const atualizaTags = (_tags) => {
        setTags(_tags)
    }



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const EditarFrase = () => {
        const config = new Configurations();
        const _body = {
            "palavraChave": formState.palavraChave,
            "sinonimos": tags ? tags.map(tag => tag) : []
        };

        axios.put(config.apiBasePath + `/sinonimos/${idFrase}`, _body)
            .then(() => {
                setLoadingAdicionar(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const adicionarPalavra = () => {
        setLoadingAdicionar(true);
        const config = new Configurations();
        const _body = {
            "palavraChave": formState.palavraChave,
            "sinonimos": tags ? tags.map(tag => tag) : []
        };

        axios.post(config.apiBasePath + `/sinonimos`, _body)
            .then(() => {
                setLoadingAdicionar(false)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const excluirResposta = () => {
        setLoadingExcluir(true);
        const config = new Configurations();
        axios.delete(config.apiBasePath + `/sinonimos/${idFrase}`)
            .then(() => {
                setLoadingExcluir(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const toggleModalExcluir = () => {
        setModalExcluir(!modalExcluir)
    }

    useEffect(() => {
        chamaFrase()
    }, [])

    const podeSalvar = () => {
        const palavraValida = !!formState.palavraChave && formState.palavraChave.trim() !== '';

        const tagValida = !!tags && tags.length

        if (editar) {
            if (palavraValida) {
                return !tagValida || !palavraValida
            }
            else {
                return !tagValida
            }
        } else {
            return !tagValida || !palavraValida
        }
    }



    return (
        <>
            <div className="row detalhes-frase">
                <div className="header-resposta border-left border-bottom border-gray">
                    <div className="row no-gutters py-3 align-items-center">
                        <div className={`${editar ? 'col-4' : 'col-6'} pl-2 text-center text-lg-left`}>
                            <h2 className="d-none d-lg-block">Termo equivalente</h2>
                        </div>

                        <div className="col-2 text-center">
                            <button disabled={podeSalvar()} className="btn btn-outline-success" onClick={() => editar ? EditarFrase() : adicionarPalavra()} >Salvar</button>
                        </div>
                        {editar &&
                            <div className="col-2 text-center">
                                <button className="btn btn-outline-danger" onClick={() => setModalExcluir(true)}>Excluir</button>
                            </div>
                        }
                        <div className="col-2 text-center">
                            <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">Voltar</button>
                        </div>
                    </div>
                </div>
            </div>

            {loading ?
                <div className="spinner-border text-primary" role="status" />
                :
                <div className='row' style={{ marginTop: '80px' }}>
                    <div className='col-12 pb-2'>
                        <label className="m-0">Palavra:</label>
                        <input name="palavraChave" type="text" className="form-control" autoComplete="off" value={formState.palavraChave} onChange={handleInputChange} />
                    </div>

                    <div className='col-12 pb-2 tags-term'>
                        <label className="m-0">Termos equivalentes:</label>
                        <InputTag atualizaTags={atualizaTags} tags={tags} textInput={true} />
                    </div>

                    <div className='col-12 text-right'>
                        {loadingAdicionar ?
                            <div className="spinner-border text-primary" role="status" />
                            :
                            <button disabled={podeSalvar()} className='btn btn-outline-success' onClick={() => editar ? EditarFrase() : adicionarPalavra()} >Salvar</button>
                        }

                    </div>


                </div>}

            <Modal isOpen={modalExcluir} toggle={toggleModalExcluir}>
                <ModalHeader toggle={toggleModalExcluir}>Excluir Termo</ModalHeader>
                <ModalBody>
                    <p className="m-0">Tem certeza que deseja excluir o termo?</p>
                    <p className="m-0">Essa operação não poderá ser desfeita.</p>
                </ModalBody>
                <ModalFooter>
                    {loadingExcluir ? <div className="spinner-border text-danger" role="status" /> : <Button color='danger' onClick={() => excluirResposta()}>excluir</Button>}
                    {' '}<Button color="secondary" onClick={toggleModalExcluir}>voltar</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default withRouter(SearchDetails);
